import { useEffect, useState } from "react";

const T = {
  dark: "#0c1118", amber: "#f9ab14", bg: "#f4f6f8",
  surface: "#ffffff", border: "#e8ecf0", muted: "#6b7280",
};

export default function ManagerPermsDialog({ open, onClose, user, initial, onSave }) {
  const ALL = [
    { key: "ceed.purchaseplans", label: "Purchase Plan Management" },
    { key: "ceed.quotes",        label: "Quote Management" },
    { key: "ceed.subscriptions", label: "Subscription Management" },
    { key: "ceed.assets",        label: "3D Assets Management" },
    { key: "ceed.reports",       label: "Report Management" },
  ];

  const [allow, setAllow] = useState(initial?.allow || []);
  const [deny,  setDeny]  = useState(initial?.deny  || []);

  useEffect(() => {
    setAllow(initial?.allow || []);
    setDeny(initial?.deny || []);
  }, [initial]);

  const toggle = (k) => {
    const next = allow.includes(k) ? allow.filter(x => x !== k) : [...allow, k];
    setAllow(next);
    setDeny(deny.filter(x => x !== k));
  };

  if (!open) return null;
  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 50, display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div onClick={onClose} style={{ position: "absolute", inset: 0, background: "rgba(0,0,0,0.3)" }} />
      <div style={{ position: "relative", width: "100%", maxWidth: 520, background: T.surface, borderRadius: 12, boxShadow: "0 8px 40px rgba(0,0,0,0.18)", padding: 24, fontFamily: "'DM Sans', sans-serif" }}>
        <h3 style={{ fontSize: 17, fontWeight: 700, marginBottom: 6 }}>
          Manager Permissions — {user?.email}
        </h3>
        <p style={{ fontSize: 13, color: T.muted, marginBottom: 16 }}>
          Select which Ceed Console pages this manager can access.
        </p>

        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          {ALL.map((it) => (
            <label key={it.key} style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 12px", border: `1px solid ${T.border}`, borderRadius: 8, cursor: "pointer" }}>
              <input type="checkbox" style={{ width: 16, height: 16 }} checked={allow.includes(it.key)} onChange={() => toggle(it.key)} />
              <span style={{ fontWeight: 500, fontSize: 14 }}>{it.label}</span>
            </label>
          ))}
        </div>

        <div style={{ marginTop: 24, display: "flex", gap: 8, justifyContent: "flex-end" }}>
          <button onClick={onClose} style={{ padding: "8px 16px", borderRadius: 8, border: `1px solid ${T.border}`, background: T.surface, cursor: "pointer", fontSize: 13 }}>Cancel</button>
          <button onClick={() => onSave({ allow, deny })} style={{ padding: "8px 16px", borderRadius: 8, border: "none", background: T.dark, color: "#fff", cursor: "pointer", fontWeight: 600, fontSize: 13 }}>Save</button>
        </div>
      </div>
    </div>
  );
}
